// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";

export default class PayPendingPaymentRequest {

    public bookingId: string = "";

    public readonly isPayPendingPaymentRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof PayPendingPaymentRequest) || ((from as any).isPayPendingPaymentRequest === true));
    }

    public static as(from?: object | null): PayPendingPaymentRequest | null {
        return (PayPendingPaymentRequest.is(from)) ? from as PayPendingPaymentRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(PayPendingPaymentRequest, "PayPendingPaymentRequest");